import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useRef, useState } from 'react';
import { device } from "../../constants";
import styled from "styled-components";
import { SearchIcon } from "../assets/icons/search-icon";
import { useTheme } from "../../contexts/ThemeContext";
import { useTranslation } from 'next-i18next';

const FormControl = styled(Form.Control)`
  border: 1px solid ${({ theme }) => theme.colors['neutral-04']};
  padding-right: 60px;
  padding-left: 24px;
  line-height: 24px;
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.colors['neutral-04']};
  height: 48px;
  border-radius: 8px;
  font-weight: 400;

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 14px;
    height: 56px;
  }

  :is([data-theme="dark"] &){
    background: transparent;
    border-color: ${({ theme }) => theme.colors['neutral-01']};
    color: ${({ theme }) => theme.colors['neutral-01']};

    &::placeholder {
      color: ${({ theme }) => theme.colors['neutral-01']};
      opacity: .8;
    }
  }
`;

const SearchButton = styled(Button)`
  position: absolute;
  box-shadow: none !important;
  transition: scale .1s;
  outline: none;
  right: 1rem;
  height: 80%;
  top: 0px !important;
  margin-top: 4px;
  margin-bottom: 5px;

  svg {
    width: 16px;
    height: 16px;
  }

  @media ${device.laptop} {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export function SearchBar({ handleSubmit }) {
  const [_search, setSearch] = useState('');
  const submitRef = useRef(null);
  const { theme } = useTheme();
  const { t } = useTranslation();
  const _handleSubmit = (event) => {
    event.preventDefault();
    event.target.value = _search
    handleSubmit(event)
  }

  useEffect(() => {
    if (_search === undefined || _search === '') {
      submitRef.current.click()
    }
  }, [_search])

  return (
    <Form
      noValidate
      id="searchbar"
      autoComplete="false"
      onSubmit={_handleSubmit}
      style={{
        marginBottom: '40px'
      }}
    >
      <Form.Group className="position-relative">
        <FormControl
          type="text"
          name="search"
          value={_search}
          placeholder={t("blog.searchPlaceholder")}
            onChange={(event) => {
              setSearch(event.target.value);
            }}
        />

        <SearchButton ref={submitRef} variant="link" type="submit">
          <SearchIcon color={theme === 'dark' ? '#fff' : '#7F7F7F'} />
        </SearchButton>
      </Form.Group>
    </Form>
  )
}
